module.exports = __webpack_public_path__ + "static/media/0027_L_ESPACE_DEGUSTATION_SANS.087d0c66.png";